<template>
  <header class="wad4-menu-v2">
    <div class="wad4-menu-v2-navbar">
      <nav class="wad4__container" role="navigation" aria-label="Main Navigation">
        <ul class="wad4-menu-v2-items" role="menubar" >
          <!-- Logo -->
          <li class="wad4-menu-v2-items__item">
            <a class="wad4-menu-v2-items__item-logo wad4-menu-v2__focusable" @keydown="handleKeydown" :href="base_url" role="img" aria-label="Homepage"
               id="wad4MenuV2Item_logo" ref="wad4MenuV2Item_logo" tabindex="0" >
              <svg width="86" height="28" viewBox="0 0 86 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>WAD Home Page</title>
                <path d="M46.7641 0.935547H40.514L33.6121 18.9298L26.7102 0.935547H20.4601L13.5582 18.9298L6.65084 0.935547H0.40625L10.4359 27.0697H16.6805L23.5824 9.07542L30.4898 27.0697H36.7344L43.6418 9.07542L50.5437 27.0697H56.7883L46.7641 0.935547Z" fill="#FF174D"/>
                <path d="M59.9141 0.935547V7.14179L77.7933 13.9999L59.9141 20.858V27.0697L85.8784 17.1057V10.8995V10.894L59.9141 0.935547Z" fill="#FF174D"/>
              </svg>
            </a>
          </li>
          <!-- Menu item -->
          <li class="wad4-menu-v2-items__item wad4-menu-v2-items__item--desktop wad4-menu-v2__focusable" @keydown="handleKeydown" :id="`wad4MenuV2Item_i${index}`" v-for="(menuItem, index) in menuItems" tabindex="0" role="menuitem" @click.stop="onMenuItemClick($event, index, menuItem)">
            <!-- Item label -->
            <span class="wad4-menu-v2-items__item-label wad4-menu-v2__focusable" :class="{'wad4-menu-v2-items__item-label--active': highlightMenuItem(index)}">
                {{menuItem.title}}
              </span>
            <!-- Item toggle icon -->
            <svg v-if="menuItem.content" class="wad4-menu-v2-items__item-icon" :class="{'wad4-menu-v2-items__item-icon--open': activeMenuItemIndex === index}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 11.0008L3 6.00078L3.7 5.30078L8 9.60078L12.3 5.30078L13 6.00078L8 11.0008Z" fill="currentColor"/>
            </svg>
          </li>
          <!-- Spacer for new menu -->
          <li class="wad4-menu-v2-items__spacer"/>
          <!-- Login button -->
          <li class="wad4-menu-v2-items__item wad4-menu-v2-items__item__guest wad4-menu-v2__focusable" @keydown="handleKeydown" tabindex="0"  v-show="onClient && userHasAccountType(['guest'])">
            <button
                id="wad4-menu-v2-items__button"
                tabindex="0"
                class="wad4-menu-v2-items__icon wad4-menu-v2__focusable"
                @click="toggleGuestDropdown"
                @keydown="handleKeydown"
                aria-label="Open guest card"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M11.9998 2.25C13.9767 2.25 15.9065 2.85147 17.534 3.97363C19.1615 5.0958 20.4102 6.68554 21.1131 8.5332C21.816 10.3809 21.9398 12.3992 21.4696 14.3193C20.9994 16.2391 19.9584 17.9712 18.4813 19.2852L18.4803 19.2842C16.697 20.8746 14.39 21.752 12.0008 21.749H11.9998L11.9989 21.75V21.749C9.60977 21.752 7.30348 20.8752 5.52034 19.2852L5.24788 19.0342C3.9145 17.7543 2.97099 16.1194 2.53011 14.3193C2.05987 12.3992 2.18369 10.3809 2.88655 8.5332C3.58943 6.68554 4.83818 5.0958 6.46565 3.97363C8.09316 2.85147 10.023 2.25 11.9998 2.25ZM11.9998 16.5C10.9566 16.4991 9.92709 16.7405 8.993 17.2051C8.27526 17.5621 7.62905 18.0435 7.08284 18.625C8.4985 19.6783 10.2215 20.2527 11.9989 20.25H12.0018C13.7786 20.2524 15.5014 19.6777 16.9168 18.625C16.3707 18.0437 15.7252 17.562 15.0076 17.2051C14.0736 16.7405 13.044 16.4991 12.0008 16.5H11.9998ZM11.9998 3.75C10.3271 3.75 8.69337 4.25845 7.31624 5.20801C5.93935 6.15748 4.88361 7.5032 4.2889 9.06641C3.69424 10.6297 3.58843 12.3373 3.98616 13.9619C4.32275 15.3363 5.00749 16.5963 5.96663 17.625C6.63958 16.9024 7.43678 16.3031 8.32503 15.8613C9.46671 15.2935 10.7248 14.999 11.9998 15C13.2752 14.9989 14.5336 15.2934 15.6756 15.8613C16.5637 16.303 17.3602 16.9026 18.033 17.625C18.9921 16.5963 19.6768 15.3367 20.0135 13.9619C20.4112 12.3373 20.3054 10.6297 19.7108 9.06641C19.1161 7.5032 18.0603 6.15748 16.6834 5.20801C15.3063 4.25845 13.6726 3.75 11.9998 3.75ZM14.2508 9.75C14.2508 9.15344 14.0133 8.5811 13.5916 8.15918C13.1698 7.73733 12.5974 7.50013 12.0008 7.5C11.4041 7.5 10.831 7.73722 10.409 8.15918C9.98731 8.5811 9.75081 9.15345 9.75081 9.75C9.75089 10.3466 9.98719 10.9189 10.409 11.3408C10.831 11.7628 11.4041 12 12.0008 12C12.5974 11.9999 13.1698 11.7627 13.5916 11.3408C14.0135 10.9189 14.2507 10.3466 14.2508 9.75ZM15.7508 9.75C15.7507 10.7444 15.3553 11.6982 14.6522 12.4014C13.949 13.1045 12.9952 13.4999 12.0008 13.5C11.0062 13.5 10.0517 13.1046 9.34847 12.4014C8.64534 11.6982 8.25089 10.7444 8.25081 9.75C8.25081 8.75544 8.64521 7.80092 9.34847 7.09766C10.0517 6.39445 11.0063 6 12.0008 6C12.9952 6.00013 13.949 6.39457 14.6522 7.09766C15.3554 7.80092 15.7508 8.75544 15.7508 9.75Z" fill="currentColor"/>
              </svg>
            </button>
          </li>
          <!-- Profile avatar -->
          <ClientOnly>
            <li class="wad4-menu-v2-items__item wad4-menu-v2__focusable" @keydown="handleKeydown" v-show="onClient && userMappedInfo.profileCardImage" id="wad4-menu-v2-items__avatar" tabindex="0" @click.stop="onMenuItemClick($event, avatarMenuIndex, nextFocusableItemAfterAvatarClick)">
              <img v-show="userMappedInfo.profileCardImage" v-bind="userMappedInfo.profileCardImage" class="wad4-menu-v2-items__item-avatar" alt="My profile image" role="img" aria-label="Profile image">
              <svg v-show="userHasNotification" class="wad4-menu-v2-items__item-notification" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="5.25" fill="#20A977" stroke="white" stroke-width="1.5"/>
              </svg>
            </li>
          </ClientOnly>
          <!-- Mobile burger button -->
          <li class="wad4-menu-v2-items__item wad4-menu-v2-items__item--mobile" @click="burgerMenuClick" tabindex="0">
            <svg v-show="!burgerMenuOpen || profileCardIsOpen" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 13.3333V10H35V13.3333H5ZM5 21.6667H35V18.3333H5V21.6667ZM5 30H35V26.6667H5V30Z" fill="currentColor"/>
            </svg>
            <svg v-show="burgerMenuOpen && !profileCardIsOpen" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M31.6654 10.683L29.3154 8.33301L19.9987 17.6497L10.682 8.33301L8.33203 10.683L17.6487 19.9997L8.33203 29.3163L10.682 31.6663L19.9987 22.3497L29.3154 31.6663L31.6654 29.3163L22.3487 19.9997L31.6654 10.683Z" fill="currentColor"/>
            </svg>
          </li>
        </ul>
        <div id="wad4-menu-v2__skip-to-content" class="wad4-button-primary wad4-menu-v2-items__item-skip-to-content wad4-menu-v2__focusable" tabindex="0"
             @keydown="handleKeydown" @click="handleSkipClick" @blur="onSkipButtonLostFocus" autofocus>
          Skip to main content
        </div>
      </nav>
    </div>
    <div v-if="!profileCardIsOpen && !guestCardIsOpen" class="wad4-menu-v2-overlay" :class="{'wad4-menu-v2-overlay--open': openOverlay}" @click.stop="closeMenuContent" role="presentation"></div>
    <div class="wad4-menu-v2-content" :class="{'wad4-menu-v2-content--open': contentIsOpen, 'wad4-menu-v2-content--split-reverse': activeMenuItemIndex===3, 'wad4-menu-v2-content--profile': profileCardIsOpen || guestCardIsOpen}"
         :id="activeMenuItemIndex !== null ? `wad4MenuV2ItemContent_i${activeMenuItemIndex}` : 'wad4MenuV2ItemContent'"
         tabindex="0" role="dialog" aria-labelledby="menu-content-title">
      <!-- region 'for companies' drop down -->
      <div v-show="activeMenuItemIndex === 7" class="wad4-menu-v2-content__hide-on-mobile">
        <div class="wad4-menu-v2-content__body">
          <div class="wad4__container wad4__container--columns">
            <div v-for="(col, colIndex) in menuItems[7].content.columns" :key="colIndex" class="wad4-menu-v2-content__card">
              <div class="wad4-menu-v2-content__card-title">{{ col.title }}</div>
              <ul class="wad4-menu-v2-content__card-list">
                <li v-for="(item, itemIndex) in col.items" :key="itemIndex" class="wad4-menu-v2-content__card-list-item">
                  <a :id="`wad4-menu-v2__companies-left_i${colIndex}${itemIndex}`"
                     class="wad4-menu-v2-content__card-list-link wad4-menu-v2-content__card-list-link__title wad4-menu-v2__focusable"
                     :href="item.link"
                     @keydown="handleKeydown"
                  >
                    <div class="wad4-menu-v2-content__card-list-link__wrapper wad4-menu-v2-content__card-list-link__wrapper--companies">
                      <div class="wad4-menu-v2-content__card-list-link-label--companies">
                        <div class="wad4-menu-v2-content__card-list-link-label">
                          {{ item.title }}
                        </div>
                        <span v-if="item.badge" class="wad4-menu-v2__badge">{{ item.badge }}</span>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- region 'events' drop down -->
      <div v-show="activeMenuItemIndex === 6" class="wad4-menu-v2-content__hide-on-mobile">
          <div class="wad4__container wad4__container--columns">
            <div
                v-for="(col, colIndex) in menuItems[6].content.columns"
                :key="colIndex"
                class="wad4-menu-v2-content__card wad4-menu-v2-content__card--attend"
                :class="{ 'wad4-menu-v2-content__card--highlight': colIndex === 1 }"
            >
              <div class="wad4-menu-v2-content__card-title wad4-typo__display--semi-bold wad4-typo__text--xl">{{ col.title }}</div>
              <ul class="wad4-menu-v2-content__card-list">
                <li
                    v-for="(item, itemIndex) in col.items"
                    :key="itemIndex"
                    class="wad4-menu-v2-content__card-list-item"
                >
                  <a :id="`wad4-menu-v2__attend-left_i${colIndex}${itemIndex}`"
                     class="wad4-menu-v2-content__card-list-link wad4-menu-v2-content__card-list-link__title wad4-menu-v2__focusable"
                     :href="item.link"
                     @keydown="handleKeydown"
                  >
                    <div class="wad4-menu-v2-content__card-list-link__wrapper wad4-menu-v2-content__card-list-link__wrapper--companies wad4-space-top--lg">
                      <div class="wad4-menu-v2-content__card-list-link-label--companies">
                        <div class="wad4-menu-v2-content__card-list-link-label wad4-typo__display--semi-bold wad4-typo__text--md">
                          {{ item.title }}
                        </div>
                        <span v-if="item.badge" class="wad4-menu-v2__badge" :class="item.badgeClass">{{ item.badge }}</span>
                      </div>
                    </div>
                  </a>
                  <div class="wad4-menu-v2-content__card-list-link-label--companies">
                    <div class="wad4-menu-v2-content__card-list-subtitle wad4-typo__text--sm">
                      {{ item.subtitle }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      </div>
      <!-- Profile card -->
      <div v-if="profileCardIsOpen" class="wad4-menu-v2-profile wad4__container" :id="`wad4-menu-v2-items__dropdown_${avatarMenuIndex}`">
        <div class="wad4-menu-v2-profile-card">
          <div class="wad4-menu-v2-profile-card__account">
            <div class="wad4-menu-v2-profile-card__account-avatar-wrapper">
              <img v-bind="userMappedInfo.profileCardImage" class="wad4-menu-v2-profile-card__account-image">
              <svg v-if="userHasNotification" class="wad4-menu-v2-items__item-notification" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="5.25" fill="#20A977" stroke="white" stroke-width="1.5"/>
              </svg>
            </div>
            <div class="wad4-menu-v2-profile-card__account-text">
              <span class="wad4-menu-v2-profile-card__account-title">{{ user.full_name }}</span>
              <span class="wad4-menu-v2-profile-card__account-subtitle">{{ user.email }}</span>
            </div>
          </div>
          <div class="wad4-menu-v2-profile-card__spacer"></div>
          <div class="wad4-menu-v2-profile-card__theme-wrapper">
            <div class="wad4-menu-v2-profile-card__theme-toggle">
              <button
                  id="wad4-menu-v2-theme-light"
                  class="wad4-menu-v2-profile-card__theme-toggle-button wad4-menu-v2__focusable"
                  :class="{ 'wad4-menu-v2-profile-card__theme-toggle-button--active': $theme.currentOption.value === 'light' }"
                  @click="$theme.set('light'); activeIndex = 0"
                  aria-label="Light mode"
                  tabindex="0"
                  @keydown="handleKeydown"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M11.25 21V18.75C11.25 18.3358 11.5858 18 12 18C12.4142 18 12.75 18.3358 12.75 18.75V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21ZM6.69629 16.2422C6.98919 15.9493 7.46494 15.9493 7.75781 16.2422C8.05069 16.5351 8.05065 17.0108 7.75781 17.3037L6.16602 18.8945C5.8731 19.1872 5.39828 19.1873 5.10547 18.8945C4.81266 18.6017 4.81283 18.1269 5.10547 17.834L6.69629 16.2422ZM16.2422 16.2422C16.5351 15.9493 17.0108 15.9493 17.3037 16.2422L18.8945 17.834C19.1872 18.1269 19.1873 18.6017 18.8945 18.8945C18.6017 19.1873 18.1269 19.1872 17.834 18.8945L16.2422 17.3037C15.9493 17.0108 15.9493 16.5351 16.2422 16.2422ZM15 12C15 11.2044 14.6837 10.4415 14.1211 9.87891C13.5585 9.3163 12.7956 9 12 9C11.2044 9 10.4415 9.3163 9.87891 9.87891C9.3163 10.4415 9 11.2044 9 12C9 12.7956 9.3163 13.5585 9.87891 14.1211C10.4415 14.6837 11.2044 15 12 15C12.7956 15 13.5585 14.6837 14.1211 14.1211C14.6837 13.5585 15 12.7956 15 12ZM5.25 11.25C5.66421 11.25 6 11.5858 6 12C6 12.4142 5.66421 12.75 5.25 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H5.25ZM21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H18.75C18.3358 12.75 18 12.4142 18 12C18 11.5858 18.3358 11.25 18.75 11.25H21ZM5.10547 5.10547C5.39828 4.81266 5.8731 4.81283 6.16602 5.10547L7.75781 6.69629C8.05066 6.98919 8.05069 7.46494 7.75781 7.75781C7.46494 8.05069 6.98919 8.05066 6.69629 7.75781L5.10547 6.16602C4.81283 5.8731 4.81266 5.39828 5.10547 5.10547ZM17.834 5.10547C18.1269 4.81283 18.6017 4.81266 18.8945 5.10547C19.1873 5.39828 19.1872 5.8731 18.8945 6.16602L17.3037 7.75781C17.0108 8.05065 16.5351 8.05069 16.2422 7.75781C15.9493 7.46494 15.9493 6.98919 16.2422 6.69629L17.834 5.10547ZM11.25 5.25V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V5.25C12.75 5.66421 12.4142 6 12 6C11.5858 6 11.25 5.66421 11.25 5.25ZM16.5 12C16.5 13.1935 16.0256 14.3377 15.1816 15.1816C14.3377 16.0256 13.1935 16.5 12 16.5C10.8065 16.5 9.66227 16.0256 8.81836 15.1816C7.97445 14.3377 7.5 13.1935 7.5 12C7.5 10.8065 7.97445 9.66227 8.81836 8.81836C9.66227 7.97445 10.8065 7.5 12 7.5C13.1935 7.5 14.3377 7.97445 15.1816 8.81836C16.0256 9.66227 16.5 10.8065 16.5 12Z" fill="currentColor"/>
                </svg>
              </button>
              <button
                  id="wad4-menu-v2-theme-system"
                  class="wad4-menu-v2-profile-card__theme-toggle-button wad4-menu-v2__focusable"
                  :class="{ 'wad4-menu-v2-profile-card__theme-toggle-button--active': $theme.currentOption.value === 'system' }"
                  @click="$theme.set('system'); activeIndex = 1"
                  aria-label="System mode"
                  tabindex="0"
                  @keydown="handleKeydown"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M14.25 18H9.75V18.2568L9.74512 18.4414C9.72401 18.8709 9.62975 19.2942 9.46484 19.6924C9.38434 19.8867 9.2861 20.0727 9.1748 20.25H14.8252C14.7139 20.0727 14.6157 19.8867 14.5352 19.6924C14.3467 19.2373 14.2499 18.7494 14.25 18.2568V18ZM20.25 14.5938C19.7974 14.8555 19.2819 15 18.75 15H5.25C4.71809 15 4.20263 14.8555 3.75 14.5938V15C3.75 15.3978 3.90815 15.7792 4.18945 16.0605C4.47076 16.3419 4.85218 16.5 5.25 16.5H18.75L18.8984 16.4922C19.2417 16.458 19.5645 16.3066 19.8105 16.0605C20.0919 15.7792 20.25 15.3978 20.25 15V14.5938ZM20.25 5.25C20.25 4.85218 20.0919 4.47076 19.8105 4.18945C19.5292 3.90815 19.1478 3.75 18.75 3.75H5.25C4.85218 3.75 4.47076 3.90815 4.18945 4.18945C3.90815 4.47076 3.75 4.85218 3.75 5.25V12C3.75 12.3978 3.90815 12.7792 4.18945 13.0605C4.47076 13.3419 4.85218 13.5 5.25 13.5H18.75C19.1478 13.5 19.5292 13.3419 19.8105 13.0605C20.0566 12.8145 20.208 12.4917 20.2422 12.1484L20.25 12V5.25ZM21.75 15C21.75 15.7956 21.4337 16.5585 20.8711 17.1211C20.3085 17.6837 19.5457 18 18.75 18H15.75V18.2568L15.7607 18.4775C15.7824 18.6974 15.8361 18.9133 15.9209 19.1182C16.034 19.3912 16.2002 19.6397 16.4092 19.8486L17.0303 20.4697C17.2448 20.6842 17.3094 21.0069 17.1934 21.2871C17.0773 21.5674 16.8033 21.75 16.5 21.75H7.5C7.19665 21.75 6.92273 21.5674 6.80664 21.2871C6.6906 21.0069 6.75525 20.6842 6.96973 20.4697L7.59082 19.8486L7.73926 19.6846C7.87935 19.5139 7.99428 19.3229 8.0791 19.1182C8.19212 18.8452 8.25004 18.5523 8.25 18.2568V18H5.25C4.45435 18 3.69152 17.6837 3.12891 17.1211C2.5663 16.5585 2.25 15.7956 2.25 15V5.25C2.25 4.45435 2.5663 3.69152 3.12891 3.12891C3.69152 2.5663 4.45435 2.25 5.25 2.25H18.75C19.5456 2.25 20.3085 2.5663 20.8711 3.12891C21.4337 3.69152 21.75 4.45435 21.75 5.25V15Z" fill="currentColor"/>
                </svg>
              </button>
              <button
                  id="wad4-menu-v2-theme-dark"
                  class="wad4-menu-v2-profile-card__theme-toggle-button wad4-menu-v2__focusable"
                  :class="{ 'wad4-menu-v2-profile-card__theme-toggle-button--active': $theme.currentOption.value === 'dark' }"
                  @click="$theme.set('dark'); activeIndex = 2"
                  aria-label="Dark mode"
                  tabindex="0"
                  @keydown="handleKeydown"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M5.25 4.50211C5.25 3.73798 5.33305 2.9929 5.48828 2.27457C4.51227 2.9292 3.6687 3.77153 3.01074 4.75895C2.02548 6.23767 1.49985 7.97522 1.5 9.75211L1.51172 10.215C1.7526 14.9707 5.68444 18.7521 10.5 18.7521C12.2769 18.7523 14.0144 18.2266 15.4932 17.2414C16.4809 16.5832 17.3218 15.7383 17.9766 14.7619C17.2465 14.9199 16.5006 15.0021 15.75 15.0011V15.0021C9.95079 15.0021 5.25 10.3013 5.25 4.50211ZM6.75 4.50211C6.75 9.4729 10.7792 13.5021 15.75 13.5021H15.751C16.9395 13.5037 18.1168 13.2689 19.2139 12.8117C19.4943 12.695 19.8174 12.759 20.0322 12.9738C20.2471 13.1888 20.3114 13.5126 20.1943 13.7931C19.3962 15.7062 18.0493 17.34 16.3242 18.4894C14.7069 19.567 12.8248 20.1739 10.8877 20.2453L10.5 20.2521C4.70079 20.2521 2.95294e-08 15.5513 2.95294e-08 9.75211C-0.00015541 7.67926 0.613356 5.65292 1.7627 3.9279C2.91209 2.20285 4.5459 0.855889 6.45898 0.0577778C6.73959 -0.0592833 7.06334 0.00488457 7.27832 0.219887C7.4933 0.434898 7.55753 0.758625 7.44043 1.03922C6.99599 2.10426 6.75001 3.27303 6.75 4.50211Z" fill="currentColor"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="wad4-menu-v2-profile-card__spacer"></div>
          <div class="wad4-menu-v2-profile-card__menu">
            <template v-for="item in accountSpecificMenuItems">
              <a :class="{
                  'wad4-menu-v2-profile-card__menu-item--active': item.active,
                  'wad4-menu-v2-profile-card__menu-item--notification': item.badge
                  }"
                 tabindex="0"
                 class="wad4-menu-v2-profile-card__menu-item wad4-menu-v2__focusable" :href="item.url" @keydown="handleKeydown"
                 :id="item.id">
                <div class="wad4-menu-v2__svg-wrapper" v-html="item.svg"></div>
                {{item.title}}
              </a>
              <div v-if="item.divider" class="wad4-menu-v2-profile-card__spacer"></div>
            </template>
          </div>
          <template v-if="userMappedInfo.otherAccounts.length">
            <div class="wad4-menu-v2-profile-card__spacer"></div>
            <div v-for="(account, index) in userMappedInfo.otherAccounts" :key="account.type_id" :id="`wad4-menu-v2__profile-card_account-i${index}`"
                 class="wad4-menu-v2-profile-card__account wad4-menu-v2-profile-card__account--switch wad4-menu-v2__focusable"
                 @keydown="handleKeydown" @click.prevent="switchUser(account)" tabindex="0">
              <img v-if="account.image" :src="`${account.image}?fit=crop&h=44&w=44`" class="wad4-menu-v2-profile-card__account-image">
              <div class="wad4-menu-v2-profile-card__account-text">
                <span class="wad4-menu-v2-profile-card__account-title">{{ account.full_name }}</span>
                <span class="wad4-menu-v2-profile-card__account-subtitle">{{ subtitleText(account) }}</span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="currentColor"/>
              </svg>
            </div>
          </template>
          <div class="wad4-menu-v2-profile-card__spacer"></div>
          <div class="wad4-menu-v2-profile-card__footer">
            <a :href="`${base_url}/${language}/user/logout`" class="wad4-menu-v2-profile-card__menu-item wad4-menu-v2__focusable"
               @keydown="handleKeydown" id="wad4-menu-v2-items__profile-card_sign-out" tabindex="0">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" fill="currentColor"/>
              </svg>
              Sign out
            </a>
          </div>
        </div>
      </div>
      <!-- Mobile drop down menu -->
      <ul v-if="burgerMenuOpen && !profileCardIsOpen && !guestCardIsOpen" class="wad4-menu-v2-mobile wad4__container" role="menu">
        <li class="wad4-menu-v2-mobile-item" v-for="(item, index) in menuItems" :key="index" :id="`parent-${index}`" role="menuitem" tabindex="0">
          <a v-if="!item.isExpandableOnMobile" class="wad4-menu-v2-mobile-link wad4-menu-v2__focusable" :href="item.mobileLink" :target="item.target ? item.target : '_self'">
            <span class="wad4-menu-v2-mobile-link__label">{{ item.title }}</span>
          </a>
          <div v-if="item.isExpandableOnMobile" class="wad4-menu-v2-mobile-item-expander" @click="toggleDropdown(index, $event)" @keydown.enter.stop.prevent="toggleDropdown(index, $event)" tabindex="0">
            <div class="wad4-menu-v2-mobile-item-expander__label">
              {{ item.title }}
              <svg class="wad4-menu-v2-mobile-item-expander__icon" :class="{'wad4-menu-v2-mobile-item-expander__icon--rotated': mobileExpandedItem === index}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 11.0008L3 6.00078L3.7 5.30078L8 9.60078L12.3 5.30078L13 6.00078L8 11.0008Z" fill="currentColor"/>
              </svg>
            </div>
          </div>
          <ul v-if="item.isExpandableOnMobile"
              class="wad4-menu-v2-mobile-expandable"
              :class="{'wad4-menu-v2-mobile-expandable--open': mobileExpandedItem === index}">
            <template v-if="item.content.columns">
              <li v-for="(col, colIndex) in item.content.columns" :key="colIndex" class="wad4-menu-v2-mobile-expandable-item">
                <div class="wad4-menu-v2-mobile-headings-title">{{ col.title }}</div>
                <ul class="wad4-menu-v2-mobile-headings">
                  <li v-for="(subItem, subIndex) in col.items" :key="subIndex">
                    <a class="wad4-menu-v2-mobile-link" :href="subItem.link" :target="subItem.target ? subItem.target : '_self'">
                      <div class="wad4-menu-v2-mobile-link__label wad4-menu-v2-mobile-link__label__regular">
                        {{ subItem.title }}
                        <div v-if="subItem.badge" class="wad4-menu-v2__badge" :class="subItem.badgeClass">{{ subItem.badge }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </li>
            </template>
            <template v-else>
              <li class="wad4-menu-v2-mobile-expandable-item" v-for="(subItem, subIndex) in item.content.items" :key="subIndex">
                <a v-if="!subItem.headings" :href="subItem.link" :class="subItem.mobile_css_class" :target="subItem.target ? subItem.target : '_self'">
                  <div :class="subItem.isButton ? 'wad4-button__text' : 'wad4-menu-v2-mobile-link__label'">
                    {{ subItem.title }}
                    <div v-if="subItem.badge" class="wad4-menu-v2__badge" :class="subItem.badgeClass">{{ subItem.badge }}</div>
                  </div>
                  <div v-if="subItem.subtitle" class="wad4-menu-v2-mobile-link__subtitle">{{ subItem.subtitle }}</div>
                </a>
                <div v-if="subItem.headings">{{ subItem.title }}</div>
                <ul v-if="subItem.headings" class="wad4-menu-v2-mobile-headings">
                  <li v-for="(heading, hIndex) in subItem.headings" :key="hIndex">
                    <a class="wad4-menu-v2-mobile-link" :href="heading.link" :target="heading.target ? heading.target : '_self'">
                      <span class="wad4-menu-v2-mobile-link__label">{{ heading.title }}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </template>
            <li v-if="item.content.button">
              <a :class="item.content.button.mobile_css_class" :href="item.content.button.link">
                <span class="wad4-button__text">{{item.content.button.text}}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
  <div v-if="guestCardIsOpen" class="wad4-menu-v2-profile wad4__container" :id="`wad4-menu-v2-items__dropdown_${guestMenuIndex}`">
    <div class="wad4-menu-v2-profile-card">
      <div class="wad4-menu-v2-profile-card__guest">
        <div class="wad4-menu-v2-profile-card__theme-wrapper">
          <div class="wad4-menu-v2-profile-card__theme-toggle">
            <button
                id="wad4-menu-v2-theme-light-guest"
                class="wad4-menu-v2-profile-card__theme-toggle-button wad4-menu-v2__focusable"
                :class="{ 'wad4-menu-v2-profile-card__theme-toggle-button--active': $theme.currentOption.value === 'light' }"
                @click="$theme.set('light'); activeIndex = 0"
                aria-label="Light mode"
                tabindex="0"
                @keydown="handleKeydown"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M11.25 21V18.75C11.25 18.3358 11.5858 18 12 18C12.4142 18 12.75 18.3358 12.75 18.75V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21ZM6.69629 16.2422C6.98919 15.9493 7.46494 15.9493 7.75781 16.2422C8.05069 16.5351 8.05065 17.0108 7.75781 17.3037L6.16602 18.8945C5.8731 19.1872 5.39828 19.1873 5.10547 18.8945C4.81266 18.6017 4.81283 18.1269 5.10547 17.834L6.69629 16.2422ZM16.2422 16.2422C16.5351 15.9493 17.0108 15.9493 17.3037 16.2422L18.8945 17.834C19.1872 18.1269 19.1873 18.6017 18.8945 18.8945C18.6017 19.1873 18.1269 19.1872 17.834 18.8945L16.2422 17.3037C15.9493 17.0108 15.9493 16.5351 16.2422 16.2422ZM15 12C15 11.2044 14.6837 10.4415 14.1211 9.87891C13.5585 9.3163 12.7956 9 12 9C11.2044 9 10.4415 9.3163 9.87891 9.87891C9.3163 10.4415 9 11.2044 9 12C9 12.7956 9.3163 13.5585 9.87891 14.1211C10.4415 14.6837 11.2044 15 12 15C12.7956 15 13.5585 14.6837 14.1211 14.1211C14.6837 13.5585 15 12.7956 15 12ZM5.25 11.25C5.66421 11.25 6 11.5858 6 12C6 12.4142 5.66421 12.75 5.25 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H5.25ZM21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H18.75C18.3358 12.75 18 12.4142 18 12C18 11.5858 18.3358 11.25 18.75 11.25H21ZM5.10547 5.10547C5.39828 4.81266 5.8731 4.81283 6.16602 5.10547L7.75781 6.69629C8.05066 6.98919 8.05069 7.46494 7.75781 7.75781C7.46494 8.05069 6.98919 8.05066 6.69629 7.75781L5.10547 6.16602C4.81283 5.8731 4.81266 5.39828 5.10547 5.10547ZM17.834 5.10547C18.1269 4.81283 18.6017 4.81266 18.8945 5.10547C19.1873 5.39828 19.1872 5.8731 18.8945 6.16602L17.3037 7.75781C17.0108 8.05065 16.5351 8.05069 16.2422 7.75781C15.9493 7.46494 15.9493 6.98919 16.2422 6.69629L17.834 5.10547ZM11.25 5.25V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V5.25C12.75 5.66421 12.4142 6 12 6C11.5858 6 11.25 5.66421 11.25 5.25ZM16.5 12C16.5 13.1935 16.0256 14.3377 15.1816 15.1816C14.3377 16.0256 13.1935 16.5 12 16.5C10.8065 16.5 9.66227 16.0256 8.81836 15.1816C7.97445 14.3377 7.5 13.1935 7.5 12C7.5 10.8065 7.97445 9.66227 8.81836 8.81836C9.66227 7.97445 10.8065 7.5 12 7.5C13.1935 7.5 14.3377 7.97445 15.1816 8.81836C16.0256 9.66227 16.5 10.8065 16.5 12Z" fill="currentColor"/>
              </svg>
            </button>
            <button
                id="wad4-menu-v2-theme-system-guest"
                class="wad4-menu-v2-profile-card__theme-toggle-button wad4-menu-v2__focusable"
                :class="{ 'wad4-menu-v2-profile-card__theme-toggle-button--active': $theme.currentOption.value === 'system' }"
                @click="$theme.set('system'); activeIndex = 1"
                aria-label="System mode"
                tabindex="0"
                @keydown="handleKeydown"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M14.25 18H9.75V18.2568L9.74512 18.4414C9.72401 18.8709 9.62975 19.2942 9.46484 19.6924C9.38434 19.8867 9.2861 20.0727 9.1748 20.25H14.8252C14.7139 20.0727 14.6157 19.8867 14.5352 19.6924C14.3467 19.2373 14.2499 18.7494 14.25 18.2568V18ZM20.25 14.5938C19.7974 14.8555 19.2819 15 18.75 15H5.25C4.71809 15 4.20263 14.8555 3.75 14.5938V15C3.75 15.3978 3.90815 15.7792 4.18945 16.0605C4.47076 16.3419 4.85218 16.5 5.25 16.5H18.75L18.8984 16.4922C19.2417 16.458 19.5645 16.3066 19.8105 16.0605C20.0919 15.7792 20.25 15.3978 20.25 15V14.5938ZM20.25 5.25C20.25 4.85218 20.0919 4.47076 19.8105 4.18945C19.5292 3.90815 19.1478 3.75 18.75 3.75H5.25C4.85218 3.75 4.47076 3.90815 4.18945 4.18945C3.90815 4.47076 3.75 4.85218 3.75 5.25V12C3.75 12.3978 3.90815 12.7792 4.18945 13.0605C4.47076 13.3419 4.85218 13.5 5.25 13.5H18.75C19.1478 13.5 19.5292 13.3419 19.8105 13.0605C20.0566 12.8145 20.208 12.4917 20.2422 12.1484L20.25 12V5.25ZM21.75 15C21.75 15.7956 21.4337 16.5585 20.8711 17.1211C20.3085 17.6837 19.5457 18 18.75 18H15.75V18.2568L15.7607 18.4775C15.7824 18.6974 15.8361 18.9133 15.9209 19.1182C16.034 19.3912 16.2002 19.6397 16.4092 19.8486L17.0303 20.4697C17.2448 20.6842 17.3094 21.0069 17.1934 21.2871C17.0773 21.5674 16.8033 21.75 16.5 21.75H7.5C7.19665 21.75 6.92273 21.5674 6.80664 21.2871C6.6906 21.0069 6.75525 20.6842 6.96973 20.4697L7.59082 19.8486L7.73926 19.6846C7.87935 19.5139 7.99428 19.3229 8.0791 19.1182C8.19212 18.8452 8.25004 18.5523 8.25 18.2568V18H5.25C4.45435 18 3.69152 17.6837 3.12891 17.1211C2.5663 16.5585 2.25 15.7956 2.25 15V5.25C2.25 4.45435 2.5663 3.69152 3.12891 3.12891C3.69152 2.5663 4.45435 2.25 5.25 2.25H18.75C19.5456 2.25 20.3085 2.5663 20.8711 3.12891C21.4337 3.69152 21.75 4.45435 21.75 5.25V15Z" fill="currentColor"/>
              </svg>
            </button>
            <button
                id="wad4-menu-v2-theme-dark-guest"
                class="wad4-menu-v2-profile-card__theme-toggle-button wad4-menu-v2__focusable"
                :class="{ 'wad4-menu-v2-profile-card__theme-toggle-button--active': $theme.currentOption.value === 'dark' }"
                @click="$theme.set('dark'); activeIndex = 2"
                aria-label="Dark mode"
                tabindex="0"
                @keydown="handleKeydown"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M5.25 4.50211C5.25 3.73798 5.33305 2.9929 5.48828 2.27457C4.51227 2.9292 3.6687 3.77153 3.01074 4.75895C2.02548 6.23767 1.49985 7.97522 1.5 9.75211L1.51172 10.215C1.7526 14.9707 5.68444 18.7521 10.5 18.7521C12.2769 18.7523 14.0144 18.2266 15.4932 17.2414C16.4809 16.5832 17.3218 15.7383 17.9766 14.7619C17.2465 14.9199 16.5006 15.0021 15.75 15.0011V15.0021C9.95079 15.0021 5.25 10.3013 5.25 4.50211ZM6.75 4.50211C6.75 9.4729 10.7792 13.5021 15.75 13.5021H15.751C16.9395 13.5037 18.1168 13.2689 19.2139 12.8117C19.4943 12.695 19.8174 12.759 20.0322 12.9738C20.2471 13.1888 20.3114 13.5126 20.1943 13.7931C19.3962 15.7062 18.0493 17.34 16.3242 18.4894C14.7069 19.567 12.8248 20.1739 10.8877 20.2453L10.5 20.2521C4.70079 20.2521 2.95294e-08 15.5513 2.95294e-08 9.75211C-0.00015541 7.67926 0.613356 5.65292 1.7627 3.9279C2.91209 2.20285 4.5459 0.855889 6.45898 0.0577778C6.73959 -0.0592833 7.06334 0.00488457 7.27832 0.219887C7.4933 0.434898 7.55753 0.758625 7.44043 1.03922C6.99599 2.10426 6.75001 3.27303 6.75 4.50211Z" fill="currentColor"/>
              </svg>
            </button>
        </div>
        </div>
        <div class="wad4-menu-v2-profile-card__spacer"></div>

        <div class="wad4-menu-v2-profile-card__guest-button">
          <a class="wad4-button-primary wad4-menu-v2__focusable"  id="wad4-menu-v2-sign-out" :href="loginUrl" tabindex="0" @keydown="handleKeydown">
            <span class="wad4-button__text wad4-menu-v2-items__button-text">Login</span>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Arrow right alt">
                <path id="Vector" d="M14.5 18.6382L13.1 17.1882L16.65 13.6382H4.5V11.6382H16.65L13.1 8.08818L14.5 6.63818L20.5 12.6382L14.5 18.6382Z" fill="white"/>
              </g>
            </svg>
          </a>
        </div>
    </div>
  </div>
  </div>
    </div>
  </header>
</template>
<script setup lang="ts">
const { $api, $theme } = useNuxtApp();
const { getImageUrl, fixedWidthImageParams } = useImageCdn();

const route = useRoute();
const rc = useRuntimeConfig();

const base_url = computed(() => (rc.public.wadPlatformBaseUrl as string) || '');
const language = computed(() => (route.params.lang as string | undefined) || (rc.public.wadDefaultLang as string) || 'en');
const activeMenuItemIndex = ref<number | null>(null);
const contentIsOpen = computed(() =>
    activeMenuItemIndex.value !== null ||
    profileCardIsOpen.value ||
    guestCardIsOpen.value ||
    burgerMenuOpen.value
);
const loginRedirect = ref('');
const currentPath = ref('');
const mobileExpandedItem = ref<number | null>(null);
const currentFocusableButton = ref<string | null>(null);
const avatarMenuIndex = 100 as const;
const tabCount = ref(0);
const showSkipLink = ref(false);
const onClient = computed(() => import.meta.client);
const activeIndex = ref(0);
const { user, hasAccountType, hasPermission } = useAuthUser()
const guestMenuIndex = 1;
const burgerMenuOpen = ref(false);

const guestCardIsOpen = computed(() => activeMenuItemIndex.value === guestMenuIndex);
function toggleGuestDropdown() {
  activeMenuItemIndex.value =
      activeMenuItemIndex.value === guestMenuIndex ? null : guestMenuIndex;
}

const userHasAccountType = (types: Array<AccountType>) =>
    hasAccountType(types).value
const userHasPermission = (perm: string) => hasPermission(perm).value;
function userAccountTypeActive(permission: Array<User['account_type']>) {
  return permission.includes(user.value.account_type);
}

function subtitleText(account: any) {
  switch (account.type) {
    case 'developer': return 'Developer Account'
    case 'company': return 'Company Account'
    case 'admin': return 'Admin Account'
    default:  ''
  }
}

async function switchUser(account: { type: string; type_id: number; home: string }) {
  try {
    await $api('/v2/user/accounts/default', {
      method: 'PUT',
      body: {
        account_type: account.type
      },
    });

    window.location.href = account.home;
  } catch (err) {
    console.error('Failed to switch account', err);
  }
}

function isActiveMenuItemByRoute(pathname: string) {
  return import.meta.client ? window.location.pathname === pathname : false;
}

const currentAccountType = computed<'guest' | 'dev' | 'company' | 'admin' | 'generic'>(() => {
  if(!onClient.value) {
    return 'guest';
  }

  if(userAccountTypeActive(['developer'])) {
    return 'dev';
  }

  if(userAccountTypeActive(['company'])) {
    return 'company';
  }

  if(userAccountTypeActive(['admin'])) {
    return 'admin';
  }

  if(userAccountTypeActive(['generic'])) {
    return 'generic';
  }

  return 'guest';
})

const loginUrl = computed(() => `${base_url.value}/${language.value}/user/login${loginRedirect.value}`);

const nextFocusableItemAfterAvatarClick = computed(() => {
  if(userAccountTypeActive(['developer'])) {
    return { firstAccessible: 'wad4-menu-v2-dev-0' };
  }

  if(userAccountTypeActive(['company'])) {
    return { firstAccessible: 'wad4-menu-v2-company-0' };
  }

  if(userAccountTypeActive(['admin'])) {
    return { firstAccessible: 'wad4-menu-v2-admin-0' };
  }

  if(userAccountTypeActive(['generic'])) {
    return { firstAccessible: 'wad4-menu-v2-generic-0' };
  }

  return { firstAccessible: '' };
})

const userMappedInfo = computed(() => {
  if(!onClient.value) {
    return {
      profileImage: { sizes: null as any, src: null as any, srcset: null as any },
      profileCardImage: null as any,
      otherAccounts: [] as any[],
      skills: [] as any[]
    }
  }
  const src = user.value.image_url || getImageUrl('/public/default-avatar.png');
  return {
    profileImage: userHasAccountType(['guest']) ? { sizes: null as any, src: null as any, srcset: null as any } : fixedWidthImageParams(src, 44, 1),
    profileCardImage: userHasAccountType(['guest']) ? null : fixedWidthImageParams(src, 60, 1),
    otherAccounts: !userHasAccountType(['guest']) && user.value.accounts ? user.value.accounts.filter(a => a.current === false) : [],
    skills: userHasAccountType(['developer']) ? [...((user.value as any).skills || [])].sort((a, b) => b.years_of_experience - a.years_of_experience) : []
  }
})

const openOverlay = computed(() => activeMenuItemIndex.value !== null);
const profileCardIsOpen = computed(() => activeMenuItemIndex.value === avatarMenuIndex)
const userHasNotification = computed(() => accountSpecificMenuItems.value.filter(el => (el as any).badge).length)


watch(profileCardIsOpen, (isOpen) => {
  if (isOpen) {
    nextTick(() => {
      document.getElementById('wad4-menu-v2-theme-light')?.focus();
    });
  }
});

const menuItems = computed(() => {
  return [
      {
        title: 'Discover',
        firstAccessible: 'wad4-menu-v2__discover_0',
        directLink: `${base_url.value}/${language.value}/videos`,
        mobileLink: `${base_url.value}/${language.value}/videos`,
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/videos`,
        ],
      },
      {
        title: 'LIVE',
        firstAccessible: 'wad4-menu-v2__live_0',
        directLink: `${base_url.value}/${language.value}/live`,
        mobileLink: `${base_url.value}/${language.value}/live`,
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/live`,
        ],
      },
      {
        title: 'Podcast',
        firstAccessible: 'wad4-menu-v2__podcast_0',
        directLink: `${base_url.value}/${language.value}/videos?event=coffee-with-developers`,
        mobileLink: `${base_url.value}/${language.value}/videos?event=coffee-with-developers`,
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/videos?event=coffee-with-developers`,
        ],
      },
      {
        title: 'Magazine',
        firstAccessible: 'wad4-menu-v2__magazine_0',
        directLink: `${base_url.value}/${language.value}/magazine`,
        mobileLink: `${base_url.value}/${language.value}/magazine`,
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/magazine`,
        ],
      },
      {
        title: 'Tech Jobs',
        firstAccessible: 'wad4-menu-v2__jobs_0',
        directLink: `${base_url.value}/${language.value}/jobs`,
        mobileLink: `${base_url.value}/${language.value}/jobs`,
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/jobs`,
        ],
      },
      {
        title: 'Companies',
        firstAccessible: 'wad4-menu-v2__companies_0',
        directLink: `${base_url.value}/${language.value}/companies`,
        mobileLink: `${base_url.value}/${language.value}/companies`,
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/companies`,
        ],
      },
      {
        title: 'Events',
        firstAccessible: 'wad4-menu-v2__attend-left_i00',
        isExpandableOnMobile: true,
        isStatic: false,
        activePaths: [
          'https://www.wearedevelopers.com/world-congress',
          'https://www.wearedevelopers.com/world-congress/tech-leaders',
          'https://www.wearedevelopers.com/world-congress/hr-leaders-summit',
          'https://www.wearedevelopers.com/world-congress-us',
          'https://wearedevelopers.com/conference-india',
        ],
        content: {
          slide: true,
          columns: [
            {
              title: 'For Developers',
              items: [
                {
                  title: 'World Congress 2026',
                  subtitle: 'Berlin, Germany, 8-10th July 2026',
                  link: 'https://www.wearedevelopers.com/world-congress',
                  badge: 'Europe',
                  badgeClass: 'wad4-menu-v2__badge--europe'
                },
                {
                  title: 'World Congress 2026',
                  subtitle: 'San José, CA, 23-25th September 2026',
                  link: 'https://www.wearedevelopers.com/world-congress-us',
                  badge: 'North America',
                  badgeClass: 'wad4-menu-v2__badge--north-america'
                },
                {
                  title: 'Conference 2026',
                  subtitle: 'Bengaluru, India, Spring 2026',
                  link: 'https://wearedevelopers.com/conference-india',
                  badge: 'India',
                  badgeClass: 'wad4-menu-v2__badge--india'
                }
              ]
            },
            {
              title: 'For Tech Leaders',
              items: [
                {
                  title: 'Tech Leaders Summit 2026',
                  subtitle: 'Berlin, Germany, 8-10th July 2026',
                  link: 'https://www.wearedevelopers.com/world-congress/tech-leaders',
                  badge: 'Europe',
                  badgeClass: 'wad4-menu-v2__badge--europe'
                },
                /*{
                  title: 'Tech Leaders Summit 2026',
                  subtitle: 'San José, CA, 23-25th September 2026',
                  link: '',
                  badge: 'North America',
                  badgeClass: 'wad4-menu-v2__badge--north-america'
                }*/
              ]
            },
            {
              title: 'For Leaders in HR/TA/Recruiting',
              items: [
                {
                  title: 'HR Leaders Summit 2026',
                  subtitle: 'Berlin, Germany, 8-10th July 2026',
                  link: 'https://www.wearedevelopers.com/world-congress/hr-leaders-summit',
                  badge: 'Europe',
                  badgeClass: 'wad4-menu-v2__badge--europe'
                },
                /*{
                  title: 'HR Leaders Summit 2026',
                  subtitle: 'San José, CA, 23-25th September 2026',
                  link: '',
                  badge: 'North America',
                  badgeClass: 'wad4-menu-v2__badge--north-america'
                }*/
              ]
            }
          ]
        }
      },
      {
        title: 'For Business',
        isExpandableOnMobile: true,
        firstAccessible: 'wad4-menu-v2__companies-left_i00',
        isStatic: true,
        activePaths: [
          `${base_url.value}/${language.value}/talent-marketing-membership`,
          `${base_url.value}/${language.value}/developer-recruiting-membership`,
          `${base_url.value}/${language.value}/product-marketing-membership`,
          `${base_url.value}/${language.value}/event-partnerships`,
          `${base_url.value}/${language.value}/company/post-job`,
          'https://www.wearedevelopers.com/business/resources',
          'https://www.wearedevelopers.com/business/developer-survey-24',
          'https://www.wearedevelopers.com/en/business/developer-salary-calculator',
          'https://www.wearedevelopers.com/business/newsletter',
          'https://www.wearedevelopers.com/business/blog'
        ],
        content: {
          slide: true,
          columns: [
            {
              title: 'Solutions',
              items: [
                {
                  title: 'Employer Branding',
                  link: `${base_url.value}/${language.value}/talent-marketing-membership`
                },
                {
                  title: 'Tech Recruiting',
                  link: `${base_url.value}/${language.value}/developer-recruiting-membership`
                },
                {
                  title: 'Product Marketing',
                  link: `${base_url.value}/${language.value}/product-marketing-membership`
                },
                {
                  title: 'Event Partnerships',
                  link: `${base_url.value}/${language.value}/event-partnerships`,
                  badge: '2026'
                },
                {
                  title: 'Post a job',
                  link: `${base_url.value}/${language.value}/company/post-job`
                }
              ]
            },
            {
              title: 'Products',
              items: [
                {
                  title: 'Talent Marketing Membership',
                  link: `${base_url.value}/${language.value}/talent-marketing-membership`
                },
                {
                  title: 'Product Marketing Membership',
                  link: `${base_url.value}/${language.value}/product-marketing-membership`
                },
                {
                  title: 'WeAreDevelopers World Congress',
                  link: 'https://www.wearedevelopers.com/world-congress'
                },
                {
                  title: 'Job Platform',
                  link: `${base_url.value}/${language.value}/jobs`
                }
              ]
            },
            {
              title: 'Insights',
              items: [
                {
                  title: 'Resources',
                  link: 'https://www.wearedevelopers.com/business/resources'
                },
                {
                  title: 'Developer survey',
                  link: 'https://www.wearedevelopers.com/business/developer-survey-24'
                },
                {
                  title: 'Salary calculator',
                  link: 'https://www.wearedevelopers.com/en/business/developer-salary-calculator'
                },
                {
                  title: 'Newsletter',
                  link: 'https://www.wearedevelopers.com/business/newsletter'
                },
                {
                  title: 'Blog',
                  link: 'https://www.wearedevelopers.com/business/blog'
                }
              ]
            }
          ],
        },
      }
    ]
});

const accountSpecificMenuItems = computed(() => {
  const dev = [
    {
      title: 'For you',
      url: `${base_url.value}/${language.value}/developer-dashboard`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-dev-0',
      active: isActiveMenuItemByRoute(`/${language.value}/developer-dashboard`),
      badge: !(user.value as any).developer_dashboard_last_visited_at ? 'New' : false,
    },
    {
      title: 'Your profile',
      url: `${base_url.value}/${language.value}/user/profile`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-dev-1',
      active: isActiveMenuItemByRoute(`/${language.value}/my-profile/settings`),
    }
  ]

  const company = [
    {
      title: 'Dashboard',
      url: `${base_url.value}/${language.value}/company-dashboard`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 21V9L12 3L20 9V21H14V14H10V21H4ZM6 19H8V12H16V19H18V10L12 5.5L6 10V19Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-company-0',
      active: isActiveMenuItemByRoute(`/${language.value}/company-dashboard`),
      badge: !(user.value as any).company_dashboard_last_visited_at ? 'New' : false,
      visible: true
    },
    {
      title: 'Post a job',
      url: `${base_url.value}/${language.value}/company/post-job`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 11c-.283 0-.521-.096-.712-.288A.982.982 0 0 1 8 10c0-.283.096-.521.288-.713C8.479 9.096 8.717 9 9 9h6c.283 0 .521.096.713.287.191.192.287.43.287.713 0 .283-.095.521-.287.712-.192.192-.43.288-.713.288H9Zm0 3c-.283 0-.521.096-.712.288-.192.191-.288.429-.288.712 0 .283.096.521.288.713.191.192.429.287.712.287h6c.283 0 .521-.095.713-.287.191-.192.287-.43.287-.713 0-.283-.096-.521-.287-.712A.982.982 0 0 0 15 14H9Zm0 3c-.283 0-.521.096-.712.288A.982.982 0 0 0 8 18c0 .283.096.521.288.713.191.191.429.287.712.287h6c.283 0 .521-.096.713-.287.191-.192.287-.43.287-.713 0-.283-.096-.521-.287-.712A.982.982 0 0 0 15 17H9Zm9-8c-.283 0-.521-.096-.712-.288A.982.982 0 0 1 17 8V7h-1c-.283 0-.521-.096-.712-.287A.982.982 0 0 1 15 6c0-.283.096-.521.288-.713.191-.191.429-.287.712-.287h1V4c0-.283.096-.521.288-.713.191-.191.429-.287.712-.287.283 0 .521.096.713.287.191.192.287.43.287.713v1h1c.283 0 .521.096.713.287.191.192.287.43.287.713 0 .283-.096.521-.287.712A.982.982 0 0 1 20 7h-1v1c0 .283-.096.521-.287.712A.982.982 0 0 1 18 9ZM5 21c-.55 0-1.021-.196-1.413-.587A1.99 1.99 0 0 1 3 19V5c0-.55.196-1.021.587-1.413C3.979 3.196 4.45 3 5 3h8c.283 0 .521.096.713.287.191.192.287.43.287.713 0 .283-.096.521-.287.712-.192.192-.43.288-.713.288H5V19h14V11c0-.283.096-.521.288-.713.191-.191.429-.287.712-.287.283 0 .521.096.713.287.191.192.287.43.287.713V19c0 .55-.196 1.021-.587 1.413C20.021 20.804 19.55 21 19 21H5Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-company-1',
      active: isActiveMenuItemByRoute(`/${language.value}/company/post-job`) || isActiveMenuItemByRoute(`/${language.value}/company/jobs/edit/new`),
      divider: true,
      visible: userHasPermission('owner.company.edit-jobs'),
    },
    {
      title: 'Your profile',
      url: `${base_url.value}/${language.value}/user/profile`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-company-2',
      active: isActiveMenuItemByRoute(`/${language.value}/user/profile`),
      visible: true,
    },
    {
      title: 'Users',
      url: `${base_url.value}/${language.value}/company/users`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path d="M15.6719 9.13086C17.0419 10.0609 18.0019 11.3209 18.0019 13.0009V16.0009H22.0019V13.0009C22.0019 10.8209 18.4319 9.53086 15.6719 9.13086Z" fill="currentColor"/><path d="M14.0019 8C16.2119 8 18.0019 6.21 18.0019 4C18.0019 1.79 16.2119 0 14.0019 0C13.5319 0 13.0919 0.0999998 12.6719 0.24C13.5019 1.27 14.0019 2.58 14.0019 4C14.0019 5.42 13.5019 6.73 12.6719 7.76C13.0919 7.9 13.5319 8 14.0019 8Z" fill="currentColor"/><path d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2Z" fill="currentColor"/><path d="M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9ZM14 14H2V13.01C2.2 12.29 5.3 11 8 11C10.7 11 13.8 12.29 14 13V14Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-company-3',
      active: isActiveMenuItemByRoute(`/${language.value}/company/users`),
      badge: !(user.value as any).company_users_last_visited_at ? 'New' : false,
      visible: userHasPermission('owner.company.view-company-users'),
    },
    {
      title: 'Account',
      url: `${base_url.value}/${language.value}/company/company-account`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 9H15V3H17V5H21V7H17V9ZM3 7V5H13V7H3ZM3 19V17H9V19H3ZM13 21V19H21V17H13V15H11V21H13ZM7 11V9H9V15H7V13H3V11H7ZM21 13V11H11V13H21Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-company-4',
      active: isActiveMenuItemByRoute(`/${language.value}/company/company-account`),
      visible: userHasPermission('owner.company.view-company-users'),
    }
  ].filter(i => (i as any).visible !== false)

  const admin = [
    { id: 'wad4-menu-v2-admin-0',
      title: 'Dashboard',
      url: `${base_url.value}/${language.value}/admin/dashboard`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 21V9L12 3L20 9V21H14V14H10V21H4ZM6 19H8V12H16V19H18V10L12 5.5L6 10V19Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/dashboard`),
      visible: userHasPermission('admin.view-company-jobs')
    },
    { id: 'wad4-menu-v2-admin-1',
      title: 'Companies',
      url: `${base_url.value}/${language.value}/admin/companies`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/companies`),
      visible: userHasPermission('admin.view-company-profile')
    },
    { id: 'wad4-menu-v2-admin-2',
      title: 'Jobs',
      url: `${base_url.value}/${language.value}/admin/jobs`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 6V4H10V6H14ZM4 8V19H20V8H4ZM20 6C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.89 16 4V6H20Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/jobs`),
      visible: userHasPermission('admin.view-company-jobs')
    },
    { id: 'wad4-menu-v2-admin-3',
      title: 'Developers',
      url: `${base_url.value}/${language.value}/admin/developers`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16"><path d="M15.6719 9.13086C17.0419 10.0609 18.0019 11.3209 18.0019 13.0009V16.0009H22.0019V13.0009C22.0019 10.8209 18.4319 9.53086 15.6719 9.13086Z" fill="currentColor"/><path d="M14.0019 8C16.2119 8 18.0019 6.21 18.0019 4C18.0019 1.79 16.2119 0 14.0019 0C13.5319 0 13.0919 0.0999998 12.6719 0.24C13.5019 1.27 14.0019 2.58 14.0019 4C14.0019 5.42 13.5019 6.73 12.6719 7.76C13.0919 7.9 13.5319 8 14.0019 8Z" fill="currentColor"/><path d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2Z" fill="currentColor"/><path d="M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9ZM14 14H2V13.01C2.2 12.29 5.3 11 8 11C10.7 11 13.8 12.29 14 13V14Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/developers`),
      visible: userHasPermission('admin.view-developers')
    },
    { id: 'wad4-menu-v2-admin-4',
      title: 'Sourcing',    url: `${base_url.value}/${language.value}/admin/sourcing`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/sourcing`),
      visible: userHasPermission('admin.view-sourcing-developers')
    },
    { id: 'wad4-menu-v2-admin-5',
      title: 'Highlights',
      url: `${base_url.value}/${language.value}/admin/highlights`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/highlights`),
      visible: userHasPermission('admin.view-highlights')
    },
    { id: 'wad4-menu-v2-admin-6',
      title: 'Events',
      url: `${base_url.value}/${language.value}/admin/events`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/events`),
      visible: userHasPermission('admin.view-live-events')
    },
    { id: 'wad4-menu-v2-admin-7',
      title: 'Live Events',
      url: `${base_url.value}/${language.value}/admin/live-events`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/live-events`),
      visible: userHasPermission('admin.view-live-events')
    },
    { id: 'wad4-menu-v2-admin-8',
      title: 'Magazine',
      url: `${base_url.value}/${language.value}/admin/magazine`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '  <path d="M9 11C8.71667 11 8.47933 10.904 8.288 10.712C8.096 10.5207 8 10.2833 8 10C8 9.71667 8.096 9.479 8.288 9.287C8.47933 9.09567 8.71667 9 9 9H15C15.2833 9 15.521 9.09567 15.713 9.287C15.9043 9.479 16 9.71667 16 10C16 10.2833 15.9043 10.5207 15.713 10.712C15.521 10.904 15.2833 11 15 11H9ZM9 14C8.71667 14 8.47933 13.904 8.288 13.712C8.096 13.5207 8 13.2833 8 13C8 12.7167 8.096 12.479 8.288 12.287C8.47933 12.0957 8.71667 12 9 12H15C15.2833 12 15.521 12.0957 15.713 12.287C15.9043 12.479 16 12.7167 16 13C16 13.2833 15.9043 13.5207 15.713 13.712C15.521 13.904 15.2833 14 15 14H9ZM9 17C8.71667 17 8.47933 16.904 8.288 16.712C8.096 16.5207 8 16.2833 8 16C8 15.7167 8.096 15.479 8.288 15.287C8.47933 15.0957 8.71667 15 9 15H15C15.2833 15 15.521 15.0957 15.713 15.287C15.9043 15.479 16 15.7167 16 16C16 16.2833 15.9043 16.5207 15.713 16.712C15.521 16.904 15.2833 17 15 17H9ZM18 9C17.7167 9 17.4793 8.904 17.288 8.712C17.096 8.52067 17 8.28333 17 8V7H16C15.7167 7 15.4793 6.90433 15.288 6.713C15.096 6.521 15 6.28333 15 6C15 5.71667 15.096 5.479 15.288 5.287C15.4793 5.09567 15.7167 5 16 5H17V4C17 3.71667 17.096 3.479 17.288 3.287C17.4793 3.09567 17.7167 3 18 3C18.2833 3 18.5207 3.09567 18.712 3.287C18.904 3.479 19 3.71667 19 4V5H20C20.2833 5 20.5207 5.09567 20.712 5.287C20.904 5.479 21 5.71667 21 6C21 6.28333 20.904 6.521 20.712 6.713C20.5207 6.90433 20.2833 7 20 7H19V8C19 8.28333 18.904 8.52067 18.712 8.712C18.5207 8.904 18.2833 9 18 9ZM5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H13C13.2833 3 13.521 3.09567 13.713 3.287C13.9043 3.479 14 3.71667 14 4C14 4.28333 13.9043 4.52067 13.713 4.712C13.521 4.904 13.2833 5 13 5H5V19H19V11C19 10.7167 19.096 10.479 19.288 10.287C19.4793 10.0957 19.7167 10 20 10C20.2833 10 20.5207 10.0957 20.712 10.287C20.904 10.479 21 10.7167 21 11V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5Z" fill="currentColor"/>\n' +
          '</svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/magazine`),
      visible: userHasPermission('admin.view-magazine-content')
    },
    { id: 'wad4-menu-v2-admin-9',
      title: 'Videos',
      url: `${base_url.value}/${language.value}/admin/videos`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM12 5.5V14.5L18 10L12 5.5Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin/videos`),
      visible: userHasPermission('admin.view-videos')
    },
    { id: 'wad4-menu-v2-admin-10',
      title: 'Admin',
      url: `${base_url.value}/${language.value}/admin`,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
          '  <path d="M19.4289 12.98C19.4689 12.66 19.4989 12.34 19.4989 12C19.4989 11.66 19.4689 11.34 19.4289 11.02L21.5389 9.37C21.7289 9.22 21.7789 8.95 21.6589 8.73L19.6589 5.27C19.5689 5.11 19.3989 5.02 19.2189 5.02C19.1589 5.02 19.0989 5.03 19.0489 5.05L16.5589 6.05C16.0389 5.65 15.4789 5.32 14.8689 5.07L14.4889 2.42C14.4589 2.18 14.2489 2 13.9989 2H9.99886C9.74886 2 9.53886 2.18 9.50886 2.42L9.12886 5.07C8.51886 5.32 7.95886 5.66 7.43886 6.05L4.94886 5.05C4.88886 5.03 4.82886 5.02 4.76886 5.02C4.59886 5.02 4.42886 5.11 4.33886 5.27L2.33886 8.73C2.20886 8.95 2.26886 9.22 2.45886 9.37L4.56886 11.02C4.52886 11.34 4.49886 11.67 4.49886 12C4.49886 12.33 4.52886 12.66 4.56886 12.98L2.45886 14.63C2.26886 14.78 2.21886 15.05 2.33886 15.27L4.33886 18.73C4.42886 18.89 4.59886 18.98 4.77886 18.98C4.83886 18.98 4.89886 18.97 4.94886 18.95L7.43886 17.95C7.95886 18.35 8.51886 18.68 9.12886 18.93L9.50886 21.58C9.53886 21.82 9.74886 22 9.99886 22H13.9989C14.2489 22 14.4589 21.82 14.4889 21.58L14.8689 18.93C15.4789 18.68 16.0389 18.34 16.5589 17.95L19.0489 18.95C19.1089 18.97 19.1689 18.98 19.2289 18.98C19.3989 18.98 19.5689 18.89 19.6589 18.73L21.6589 15.27C21.7789 15.05 21.7289 14.78 21.5389 14.63L19.4289 12.98ZM17.4489 11.27C17.4889 11.58 17.4989 11.79 17.4989 12C17.4989 12.21 17.4789 12.43 17.4489 12.73L17.3089 13.86L18.1989 14.56L19.2789 15.4L18.5789 16.61L17.3089 16.1L16.2689 15.68L15.3689 16.36C14.9389 16.68 14.5289 16.92 14.1189 17.09L13.0589 17.52L12.8989 18.65L12.6989 20H11.2989L11.1089 18.65L10.9489 17.52L9.88886 17.09C9.45886 16.91 9.05886 16.68 8.65886 16.38L7.74886 15.68L6.68886 16.11L5.41886 16.62L4.71886 15.41L5.79886 14.57L6.68886 13.87L6.54886 12.74C6.51886 12.43 6.49886 12.2 6.49886 12C6.49886 11.8 6.51886 11.57 6.54886 11.27L6.68886 10.14L5.79886 9.44L4.71886 8.6L5.41886 7.39L6.68886 7.9L7.72886 8.32L8.62886 7.64C9.05886 7.32 9.46886 7.08 9.87886 6.91L10.9389 6.48L11.0989 5.35L11.2989 4H12.6889L12.8789 5.35L13.0389 6.48L14.0989 6.91C14.5289 7.09 14.9289 7.32 15.3289 7.62L16.2389 8.32L17.2989 7.89L18.5689 7.38L19.2689 8.59L18.1989 9.44L17.3089 10.14L17.4489 11.27ZM11.9989 8C9.78886 8 7.99886 9.79 7.99886 12C7.99886 14.21 9.78886 16 11.9989 16C14.2089 16 15.9989 14.21 15.9989 12C15.9989 9.79 14.2089 8 11.9989 8ZM11.9989 14C10.8989 14 9.99886 13.1 9.99886 12C9.99886 10.9 10.8989 10 11.9989 10C13.0989 10 13.9989 10.9 13.9989 12C13.9989 13.1 13.0989 14 11.9989 14Z" fill="currentColor"/>\n' +
          '</svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/admin`),
      visible: userHasPermission('admin.view-dashboard') },
    {  id: 'wad4-menu-v2-admin-11',
      title: 'Your profile',
      url: `${base_url.value}/${language.value}/user/profile`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z" fill="currentColor"/></svg>',
      active: isActiveMenuItemByRoute(`/${language.value}/user/profile`), visible: true
    },
  ].filter(i => (i as any).visible !== false)

  const generic = [
    {
      title: 'Your profile',
      url: `${base_url.value}/${language.value}/user/profile`,
      svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z" fill="currentColor"/></svg>',
      id: 'wad4-menu-v2-generic-0',
      active: isActiveMenuItemByRoute(`/${language.value}/user/profile`),
    }
  ]

  if(userAccountTypeActive(['developer'])) {
    return dev;
  }

  if(userAccountTypeActive(['company'])) {
    return company;
  }

  if(userAccountTypeActive(['admin'])) {
    return admin;
  }

  if(userAccountTypeActive(['generic'])) {
    return generic;
  }

  return [];
})

const navigationMap = computed(() => {
  const accountSpecificItemsCount = accountSpecificMenuItems.value.length;
  let leftFromSignOutButton = null;
  let sideAccountsCount = 0;
  if(!userHasAccountType(['guest'])) {
    sideAccountsCount = user.value.accounts ? (user.value.accounts.length - 1) : 0;
    leftFromSignOutButton = sideAccountsCount ? `wad4-menu-v2__profile-card_account-i${sideAccountsCount-1}` : accountSpecificMenuItems.value[Math.ceil(accountSpecificItemsCount - 1)].id;
  }
  const leftFromAvatar = `wad4MenuV2Item_i${menuItems.value.length -1}`;

  const map = {
    'wad4MenuV2Item_logo': { right: 'wad4MenuV2Item_i0' },
    'wad4MenuV2Item_i0': { right: 'wad4MenuV2Item_i1', down: 'wad4-menu-v2__for-developers_0', left: 'wad4MenuV2Item_logo' },
    'wad4-menu-v2-items__avatar': { left: leftFromAvatar, right: 'wad4-menu-v2-theme-light' },
    'wad4-menu-v2-items__button': { left: leftFromAvatar, right: 'wad4-menu-v2-theme-light-guest' },


    //navigation rules for 'for companies'
    'wad4-menu-v2__companies-left_i00': { right: 'wad4-menu-v2__companies-left_i01', down: 'wad4-menu-v2__companies-left_i01', up: 'wad4MenuV2Item_i7', left: 'wad4MenuV2Item_i7' },
    'wad4-menu-v2__companies-left_i01': { left: 'wad4-menu-v2__companies-left_i00', right: 'wad4-menu-v2__companies-left_i02', up: 'wad4-menu-v2__companies-left_i00', down: 'wad4-menu-v2__companies-left_i02' },
    'wad4-menu-v2__companies-left_i02': { left: 'wad4-menu-v2__companies-left_i01', up: 'wad4-menu-v2__companies-left_i01', right: 'wad4-menu-v2__companies-left_i03' , down: 'wad4-menu-v2__companies-left_i03'},
    'wad4-menu-v2__companies-left_i03': { up: 'wad4-menu-v2__companies-left_i02', left: 'wad4-menu-v2__companies-left_i02', right: 'wad4-menu-v2__companies-left_i04' , down: 'wad4-menu-v2__companies-left_i04'},
    'wad4-menu-v2__companies-left_i04': { up: 'wad4-menu-v2__companies-left_i03', left: 'wad4-menu-v2__companies-left_i03', right: 'wad4-menu-v2__companies-left_i10' , down: 'wad4-menu-v2__companies-left_i10'},

    'wad4-menu-v2__companies-left_i10': { right: 'wad4-menu-v2__companies-left_i11', down: 'wad4-menu-v2__companies-left_i11', up: 'wad4MenuV2Item_i7', left: 'wad4-menu-v2__companies-left_i04' },
    'wad4-menu-v2__companies-left_i11': { left: 'wad4-menu-v2__companies-left_i10', right: 'wad4-menu-v2__companies-left_i12', up: 'wad4-menu-v2__companies-left_i10', down: 'wad4-menu-v2__companies-left_i12' },
    'wad4-menu-v2__companies-left_i12': { left: 'wad4-menu-v2__companies-left_i11', up: 'wad4-menu-v2__companies-left_i11', right: 'wad4-menu-v2__companies-left_i13' , down: 'wad4-menu-v2__companies-left_i13'},
    'wad4-menu-v2__companies-left_i13': { up: 'wad4-menu-v2__companies-left_i12', left: 'wad4-menu-v2__companies-left_i12', right: 'wad4-menu-v2__companies-left_i20' , down: 'wad4-menu-v2__companies-left_i20'},

    'wad4-menu-v2__companies-left_i20': { right: 'wad4-menu-v2__companies-left_i21', down: 'wad4-menu-v2__companies-left_i21', up: 'wad4MenuV2Item_i7', left: 'wad4-menu-v2__companies-left_i13' },
    'wad4-menu-v2__companies-left_i21': { left: 'wad4-menu-v2__companies-left_i20', right: 'wad4-menu-v2__companies-left_i22', up: 'wad4-menu-v2__companies-left_i20', down: 'wad4-menu-v2__companies-left_i22' },
    'wad4-menu-v2__companies-left_i22': { left: 'wad4-menu-v2__companies-left_i21', up: 'wad4-menu-v2__companies-left_i21', right: 'wad4-menu-v2__companies-left_i23' , down: 'wad4-menu-v2__companies-left_i23'},
    'wad4-menu-v2__companies-left_i23': { left: 'wad4-menu-v2__companies-left_i22', up: 'wad4-menu-v2__companies-left_i22', right: 'wad4-menu-v2__companies-left_i24' , down: 'wad4-menu-v2__companies-left_i24'},
    'wad4-menu-v2__companies-left_i24': { up: 'wad4-menu-v2__companies-left_i23', left: 'wad4-menu-v2__companies-left_i23', right: 'wad4-menu-v2__for-companies-left_i00' , down: 'wad4-menu-v2__for-companies-left_i00'},

    //navigation rules for 'attend'
    'wad4-menu-v2__attend-left_i00': { right: 'wad4-menu-v2__attend-left_i01', down: 'wad4-menu-v2__attend-left_i01', up: 'wad4MenuV2Item_i6', left: 'wad4MenuV2Item_i6' },
    'wad4-menu-v2__attend-left_i01': { left: 'wad4-menu-v2__attend-left_i00', right: 'wad4-menu-v2__attend-left_i02', up: 'wad4-menu-v2__attend-left_i00', down: 'wad4-menu-v2__attend-left_i02' },
    'wad4-menu-v2__attend-left_i02': { left: 'wad4-menu-v2__attend-left_i01', up: 'wad4-menu-v2__attend-left_i01', right: 'wad4-menu-v2__attend-left_i10' , down: 'wad4-menu-v2__attend-left_i10'},

    'wad4-menu-v2__attend-left_i10': { up: 'wad4MenuV2Item_i6', left: 'wad4-menu-v2__attend-left_i02', right: 'wad4-menu-v2__attend-left_i20' , down: 'wad4-menu-v2__attend-left_i20'},

    'wad4-menu-v2__attend-left_i20': { up: 'wad4MenuV2Item_i6', left: 'wad4-menu-v2__attend-left_i10', right: 'wad4-menu-v2__attend-left_i20' , down: 'wad4-menu-v2__attend-left_i20'},

    'wad4-menu-v2-items__profile-card_sign-out' : {left : leftFromSignOutButton , right : null}
  }

  // Account specific avatar dropdown menu items
  map['wad4-menu-v2-theme-light'] = {
    left: 'wad4-menu-v2-items__avatar',
    right: 'wad4-menu-v2-theme-system'
  };

  map['wad4-menu-v2-theme-system'] = {
    left: 'wad4-menu-v2-theme-light',
    right: 'wad4-menu-v2-theme-dark'
  };

  map['wad4-menu-v2-theme-dark'] = {
    left: 'wad4-menu-v2-theme-system',
    right: accountSpecificItemsCount > 0
        ? `wad4-menu-v2-${currentAccountType}-0`
        : 'wad4-menu-v2-items__profile-card_sign-out'
  };
  for (let i = 0; i < accountSpecificItemsCount; i++) {
    const item = accountSpecificMenuItems.value[i];
    const id = item.id;

    if (i === 0) {
      map[id] = {
        left: 'wad4-menu-v2-theme-dark',
        right: accountSpecificItemsCount === 1
            ? 'wad4-menu-v2-items__profile-card_sign-out'
            : accountSpecificMenuItems.value[i + 1].id
      };
    } else if (i === accountSpecificItemsCount - 1) {
      map[id] = {
        left: accountSpecificMenuItems.value[i - 1].id,
        right: sideAccountsCount
            ? 'wad4-menu-v2__profile-card_account-i0'
            : 'wad4-menu-v2-items__profile-card_sign-out'
      };
    } else {
      map[id] = {
        left: accountSpecificMenuItems.value[i - 1].id,
        right: accountSpecificMenuItems.value[i + 1].id
      };
    }
  }

  map['wad4-menu-v2-theme-light-guest'] = {
    left: 'wad4-menu-v2-items__button',
    right: 'wad4-menu-v2-theme-system-guest'
  };

  map['wad4-menu-v2-theme-system-guest'] = {
    left: 'wad4-menu-v2-theme-light-guest',
    right: 'wad4-menu-v2-theme-dark-guest'
  };

  map['wad4-menu-v2-theme-dark-guest'] = {
    left: 'wad4-menu-v2-theme-system-guest',
    right: 'wad4-menu-v2-sign-out'
  };

  map['wad4-menu-v2-sign-out'] = {
    left: 'wad4-menu-v2-theme-dark-guest',
    right: null
  };

  // Avatar dropdown menu switch account items
  for(let i = 0; i < sideAccountsCount; i++) {
    if(i === 0) {
      if(userHasAccountType(['developer'])) {
        map[`wad4-menu-v2__profile-card_account-i${i}`] = {
          left: 'wad4-menu-v2-dev-1',
          right: i === sideAccountsCount - 1 ? 'wad4-menu-v2-items__profile-card_sign-out' : `wad4-menu-v2__profile-card_account-i${i + 1}`
        };
      }
      if(userHasAccountType(['company'])) {
        map[`wad4-menu-v2__profile-card_account-i${i}`] = {
          left: 'wad4-menu-v2-company-4',
          right: i === sideAccountsCount - 1 ? 'wad4-menu-v2-items__profile-card_sign-out' : `wad4-menu-v2__profile-card_account-i${i + 1}`
        };
      }
      if(userHasAccountType(['admin'])) {
        map[`wad4-menu-v2__profile-card_account-i${i}`] = {
          left: 'wad4-menu-v2-admin-11',
          right: i === sideAccountsCount - 1 ? 'wad4-menu-v2-items__profile-card_sign-out' : `wad4-menu-v2__profile-card_account-i${i + 1}`
        };
      }
      if(userHasAccountType(['generic'])) {
        map[`wad4-menu-v2__profile-card_account-i${i}`] = {
          left: 'wad4-menu-v2-generic-0',
          right: i === sideAccountsCount - 1 ? 'wad4-menu-v2-items__profile-card_sign-out' : `wad4-menu-v2__profile-card_account-i${i + 1}`
        };
      }
    } else {
      map[`wad4-menu-v2__profile-card_account-i${i}`] = {
        left: `wad4-menu-v2__profile-card_account-i${i - 1}`,
        right: i === sideAccountsCount - 1 ? 'wad4-menu-v2-items__profile-card_sign-out' : `wad4-menu-v2__profile-card_account-i${i + 1}`
      };
    }
  }

  return map;
})

function burgerMenuClick() {
  burgerMenuOpen.value = !burgerMenuOpen.value;
  activeMenuItemIndex.value = null;

  if (burgerMenuOpen.value) {
    document.body.classList.add('wad4-mobile-menu-open');
  } else {
    mobileExpandedItem.value = null;
    document.body.classList.remove('wad4-mobile-menu-open');
  }
}

function handleWindowResize() {
  if(window.innerWidth >= 900 && contentIsOpen.value) {
    burgerMenuOpen.value = false;
    document.body.classList.remove('wad4-mobile-menu-open');
  }
}

function onSkipButtonLostFocus() {
  document.getElementById('wad4-menu-v2__skip-to-content')?.classList.remove('wad4-menu-v2-items__item-skip-to-content--show');
}

function handleSkipClick() {
  showSkipLink.value = false;
  document.getElementById('wad4-menu-v2__skip-to-content')?.classList.remove('wad4-menu-v2-items__item-skip-to-content--show');
  nextTick(() => {
    const mainContent = document.getElementById('main-content');
    if(mainContent) {
      tabCount.value = 10; (mainContent as HTMLElement).focus();
    }
  });
}

function onMenuItemClick(ev: MouseEvent | PointerEvent, index: number, menuItem: any) {
  if(menuItem?.directLink) {
    window.location.href = menuItem.directLink; return;
  }
  if(activeMenuItemIndex.value === index) {
    closeMenuContent();
  }else {
    activeMenuItemIndex.value = index;
    burgerMenuOpen.value = true;
    const e = ev as any;
    if(e.pointerType !== 'mouse') {
      nextTick(() => document.getElementById(menuItem.firstAccessible)?.focus());
    }
  }
}

function closeMenuContent() {
  burgerMenuOpen.value = false;
  setTimeout(() => { activeMenuItemIndex.value = null }, 100);
}

function onBodyClick(event: Event) {
  if(activeMenuItemIndex.value && profileCardIsOpen.value) {
    const activeDropdown = document.querySelector(`#wad4-menu-v2-items__dropdown_${activeMenuItemIndex.value}`)
    if(activeDropdown && !activeDropdown.contains(event.target as Node)) {
      activeMenuItemIndex.value = null;
      burgerMenuOpen.value = false;
    }
  }
}

function highlightMenuItem(index: number) {
  if(activeMenuItemIndex.value !== null) {
    return activeMenuItemIndex.value === index;
  }
  return !!(currentPath.value && (menuItems.value[index].activePaths || []).includes(currentPath.value));
}

function toggleDropdown (index: number) {
  if(mobileExpandedItem.value === index) {
    mobileExpandedItem.value = null;
  }else {
    mobileExpandedItem.value = null;
    setTimeout(() => { mobileExpandedItem.value = index }, 300);
  }
}
function handleKeydown(event: KeyboardEvent) {
  document.getElementById('wad4MenuV2Item_logo')?.classList.remove('wad4-menu-v2__no-focus-styles')

  if(event.key === 'Tab') {
    const focusedElement = document.activeElement as HTMLElement
    tabCount.value += 1
    if(tabCount.value === 0) {
      document.getElementById('wad4-menu-v2__skip-to-content')?.focus();
    }

    if(focusedElement?.classList.contains('wad4-menu-v2__focusable')) {
      if(tabCount.value === 1 || (event.shiftKey && focusedElement.id === 'wad4MenuV2Item_logo')) {
        tabCount.value = 1;
        showSkipLink.value = true;
        nextTick(() => {
          const el = document.getElementById('wad4-menu-v2__skip-to-content');
          el?.classList.add('wad4-menu-v2-items__item-skip-to-content--show');
          setTimeout(() => el?.focus(), 10);
        })
      }else if (tabCount.value === 2) {
        showSkipLink.value = false;
        document.getElementById('wad4-menu-v2__skip-to-content')?.classList.remove('wad4-menu-v2-items__item-skip-to-content--show');
        nextTick(() => (document.getElementById('wad4MenuV2Item_logo') as HTMLElement | null)?.focus());
      }
    }
  }

  currentFocusableButton.value = (document.activeElement as HTMLElement)?.id || null;

  if(event.key === 'Escape') {
    event.preventDefault();
    burgerMenuOpen.value = false;
    activeMenuItemIndex.value = null;
    const id = currentFocusableButton.value;
    const focusBackTo =
        id?.includes('wad4-menu-v2__for-developers') ? 'wad4MenuV2Item_i3' :
            id?.includes('wad4-menu-v2__for-companies')  ? 'wad4MenuV2Item_i5' :
                id?.includes('wad4-menu-v2__attend')         ? 'wad4MenuV2Item_i2' :
                    id?.includes('wad4-menu-v2__watch')          ? 'wad4MenuV2Item_i0' :
                        id?.includes('wad4-menu-v2__read')           ? 'wad4MenuV2Item_i1' :
                            id?.includes('wad4-menu-v2-items__profile-card') ? 'wad4-menu-v2-items__avatar' : null;
    if(focusBackTo) {
      document.getElementById(focusBackTo)?.focus();
    }
    return
  }

  const focused = document.activeElement as HTMLElement | null;
  const currentId = focused?.id || '';
  const directionMap: Record<string, 'right' | 'down' | 'left' | 'up'> = {
    ArrowRight: 'right', ArrowDown: 'down', ArrowLeft: 'left', ArrowUp: 'up'
  };
  let direction: 'right' | 'down' | 'left' | 'up' | undefined = directionMap[event.key];
  if(event.code === 'Tab') {
    direction = event.shiftKey ? 'left' : 'right';
  }

  if(direction) {
    event.preventDefault()
    if(currentId.startsWith('wad4MenuV2Item_i') && currentId !== 'wad4MenuV2Item_i0') {
      const currentIndex = parseInt(currentId.replace('wad4MenuV2Item_i', ''), 10);
      const nextId = `wad4MenuV2Item_i${currentIndex + 1}`;
      const nextEl = document.getElementById(nextId);

      if(direction === 'right') {
        if(nextEl) {
          nextEl.focus();
        }else {
          const nextFocused = userHasAccountType(['guest'])
              ? document.getElementById('wad4-menu-v2-items__button')
              : document.getElementById('wad4-menu-v2-items__avatar');
          nextFocused?.focus();
        }
        return
      }

      if(direction === 'left' && currentIndex > 0) {
        const prevId = `wad4MenuV2Item_i${currentIndex - 1}`;
        document.getElementById(prevId)?.focus();
        return
      }
    }

    if(currentId === "wad4-menu-v2-items__avatar" && direction === 'right') {
      document.getElementById('wad4-menu-v2-theme-light')?.focus();
      return;
    }

    if (currentId === 'wad4-menu-v2-theme-dark' && direction === 'right') {
      const fallbackId = accountSpecificMenuItems.value[0]?.id;
      document.getElementById(fallbackId)?.focus();
      return;
    }


    if(direction === 'left' && currentId === 'wad4-menu-v2-items__button') {
      document.getElementById('wad4MenuV2Item_i5')?.focus();
      return
    }

    const nextId = navigationMap.value[currentId]?.[direction] || currentId;
    document.getElementById(nextId || '')?.focus();
  }

  if(event.key === 'Enter') {
    const el = document.activeElement as HTMLAnchorElement;
    if (el?.id === 'wad4-menu-v2-items__button') {
      return;
    }
    event.preventDefault();
    if(el?.tagName === 'A' && el.getAttribute('href')) {
      window.location.href = el.getAttribute('href')!;
    }
    if(typeof (el as any)?.click === 'function') {
      (el as any).click();
    }
  }
}

onMounted(() => {
  const url = new URL(window.location.href);
  const redirectParam = url.searchParams.has('redirect')
      ? url.searchParams.get('redirect')
      : (url.pathname === '/' ? null : encodeURIComponent(url.toString()));
  loginRedirect.value = redirectParam ? `?redirect=${redirectParam}` : '';
  currentPath.value = window.location.href;

  nextTick(() => {
    const logo = document.getElementById('wad4MenuV2Item_logo');
    logo?.classList.add('wad4-menu-v2__no-focus-styles');
    (logo as HTMLElement | null)?.focus();
  })

  document.addEventListener('click', onBodyClick);
  window.addEventListener('resize', handleWindowResize);
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onBodyClick);
  window.removeEventListener('resize', handleWindowResize);
})

watch(showSkipLink, (val) => {
  if(val) {
    setTimeout(() => {
      const skip = document.getElementById('wad4-menu-v2__skip-to-content')
      if(skip) {
        skip.setAttribute('tabindex', '-1'); skip.focus();
      }
    }, 100);
  }
})

watch(() => route.fullPath, () => {
  if(import.meta.client) {
    currentPath.value = window.location.href;
  }
})
</script>


